export const baseURL = "https://tdx4qodl72.execute-api.ap-south-1.amazonaws.com/v1"
export const kananBaseURL = "https://b9549vdb1k.execute-api.ap-south-1.amazonaws.com/v1"